import { TableOutputProcessorHelper } from './table-output-processor.helper';

export class TableBuilderHelper {
  static BindTableOutput(comp: any, CrossTabOuputData: any, block: any = null) {
    const target = block || comp;

    target.OutputdataObject = { ...(target.OutputdataObject || {}), Row: [], Column: [] } as any;

    target.CrossTabOutPutData = (target.CrossTabOutPutData || []).filter(
      (a: any) => a.colChild !== null
    );

    target.CrossTabOutPutData.forEach((item: any, index: number) => {
      const selections = TableOutputProcessorHelper.createSelections(item);
      const parents = TableOutputProcessorHelper.createParentObjects(item, selections);

      TableOutputProcessorHelper.processParent(parents.row, target.OutputdataObject.Row, selections.nested.row);
      TableOutputProcessorHelper.processParent(parents.col, target.OutputdataObject.Column, selections.nested.col);
    });

    target.OutputdataObject.flatData = CrossTabOuputData;

    if (block) {
      block.builtTableData = block.OutputdataObject;
    }
  }

  static createTable(comp: any, 
    isSampleSize: boolean,
    feature: string = 'CrosstabOutput',
    isIndexing: boolean,
    block: any = null
  ) {
    const target = block || comp;
    comp.variableTabData = comp.crossTabService.getVarTabData || [];
    if (!comp.variableTabData || comp.variableTabData.length === 0) {
      console.warn('[METADATA-WARNING] variableTabData is missing in createTable. Attempting to recover...');
    }
    comp.displayTable = true;
    comp.isDemoStudy = false;
    comp.isSig = isIndexing ? false : true;
    comp.isIndex = isIndexing ? true : false;
    comp.referenceLevelDropDown = false;
    comp.DefaultReferenceLevel = isIndexing
      ? comp.DefaultReferenceLevel
      : 'None';
    comp.selectedIndex = isIndexing ? comp.selectedIndex : '';
    const targetDataObject = target.dataObject && target.dataObject.Row && target.dataObject.Row.length > 0 ? target.dataObject : comp.dataObject;
    const targetOutputDataObject = target.OutputdataObject;

    const rowdata = targetOutputDataObject && targetOutputDataObject.Row?.length > 0 ? targetOutputDataObject.Row : targetDataObject['Row'];
    const RowNesting = targetDataObject['RowNesting'];
    const columndata = targetOutputDataObject && targetOutputDataObject.Column?.length > 0 ? targetOutputDataObject.Column : targetDataObject['Column'];
    const ColNesting = targetDataObject['ColNesting'];
    const Filter = targetDataObject['Filter'];
    let isTimePeriodPresent = (comp.variableTabData || []).filter(
      (a: any) => a.is_time_Period_Present === true
    );
    const columnDataLength: number =
      columndata.length > 0 ? columndata.length : 0;
    let isDimensionPresent = (comp.variableTabData || []).filter(
      (a: any) => a.is_dimension_Present === true
    );

    comp.is_Time_Period_Present = (comp.variableTabData && comp.variableTabData.length > 0)
      ? (isTimePeriodPresent.length > 0)
      : (target && target.is_Time_Period_Present !== undefined ? target.is_Time_Period_Present : true);

    comp.is_dimension_Present = isDimensionPresent.length == 0 ? false : true;
    comp.is_indexingShow =
      comp.selectedDataFormat == 'Respondent Level' && comp.is_indexing
        ? columnDataLength > 1
          ? false
          : true
        : false;
    target.isDisableReference = (target.IndexData && target.IndexData.length <= 1) ? true : (columnDataLength > 1 ? true : false);
    const TimePeriodinColumn = ((columndata as any[]) || []).filter((parent: any) => {
      return (parent.Data || []).some((child: any) => child.isTimePeriod === true || child.isTimePeriod === 'true');
    });

    const isDefaultRespGrp = comp.filterDataByCalculationType(rowdata as any, 'respgrp');
    const isMeanMetric = comp.filterDataByCalculationType(rowdata as any, 'mean');
    const isMultiPunchRow = comp.filterDataByCalculationType(rowdata as any, 'multipunch');
    const isMultiPunchColumn = comp.filterDataByCalculationType(columndata as any, 'multipunch');
    comp.updateChartDisablingFlags(block);
    if (isSampleSize) {
      comp.isLineChartClick = comp.isLineChartClick || comp.isTableClick;
      comp.isVerticalGroupBarChartClick =
        comp.isVerticalGroupBarChartClick || comp.isTableClick;
      comp.isVerticalBarChartClick =
        comp.isVerticalBarChartClick || comp.isTableClick;
      comp.isVerticalStackChartClick =
        comp.isVerticalStackChartClick || comp.isTableClick;
      comp.isTableClick = false;
      comp.displayTable = !(
        comp.isLineChartClick ||
        comp.isVerticalGroupBarChartClick ||
        comp.isVerticalStackChartClick
      );
      comp.isData = !(
        comp.isLineChartClick ||
        comp.isVerticalGroupBarChartClick ||
        comp.isVerticalStackChartClick
      );
    } else {
      comp.isTableClick = false;
      comp.isLineChartClick = false;
      comp.isVerticalGroupBarChartClick = false;
      comp.isVerticalBarChartClick = false;
      comp.isVerticalStackChartClick = false;
      comp.isData = true;
      comp.DefaultDataDropDown = comp.DEFAULT_VALUES?.DATA || 'data';
      comp.isTranspose = false;
      comp.displayTable = true;
      comp.isTotal = comp.isIndex ? comp.isTotal : false;
      target.isDisablePairWise = true;
      if (
        comp.dataObject.ColNesting.length === 0 &&
        comp.dataObject.Column.length === 1 &&
        comp.dataObject.Column[0].Data.length <= 10
      )
        target.isDisablePairWise = false;
    }
    comp.isSampleSize = false;
    comp.isWeightedLabel = false;
    comp.sampleSizeDropdown = false;
    comp.confidenceLevelDropDown = false;

    const matchColumnFound = comp.isLevel1TimePeriodPresent(
      comp.listCItemsList
    );
    const matchColumnNestFound = comp.isLevel1TimePeriodPresent(
      comp.listDItemsList
    );
    const matchFilterNestFound = comp.isLevel1TimePeriodPresent(
      comp.listEItemsList
    );

    const matchColumnDimension = comp.isDimensionPresent(comp.listCItemsList);

    const matchColumnNestDimension = comp.isDimensionPresent(
      comp.listDItemsList
    );

    const matchFilterDimension = comp.isDimensionPresent(comp.listEItemsList);

    const distinctValuesForListA = comp.getDistinctLevel0Values(
      comp.listAItemsList
    );

    const distinctValuesForListC = comp.getDistinctLevel0Values(
      comp.listCItemsList
    );
    const distinctValuesForListD = comp.getDistinctLevel0Values(
      comp.listDItemsList
    );
    const distinctValuesForListE = comp.getDistinctLevel0Values(
      comp.listEItemsList
    );

    const allDistinctValues = [
      ...distinctValuesForListC,
      ...distinctValuesForListD,
      ...distinctValuesForListE,
    ];

    const allDistinctValueAggregated = [
      ...distinctValuesForListA,
      ...distinctValuesForListC,
      ...distinctValuesForListD,
      ...distinctValuesForListE,
    ];

    const distinctEntryList = comp.getDistinctENtryList(comp.entryList);

    const distinctAggregatedMetric = comp.getDistinctAggregaredMetrics(
      comp.variableTabData
    );

    const allEntryListPresent = distinctEntryList.every((entry: any) =>
      allDistinctValues.includes(entry)
    );

    const allEntryListPresentAggregated = distinctAggregatedMetric.every(
      (entry: any) => allDistinctValueAggregated.includes(entry)
    );

    const matchingCount = distinctEntryList.filter((entry: any) =>
      allDistinctValues.includes(entry)
    ).length;

    let Isshowpopup = false;

    if (Isshowpopup == false) {

      comp.SelectionSummary();
      comp.isCreateBtnClick = true;
      comp.clearOutputDataObject();
      target.isTableLoading = true;
      var weightColumnName: string = '';
      var isBoostFactor: boolean = false;

      if (target.DefaultWeight.trim() == 'Boost Factor') {
        weightColumnName = comp.WeightDropDownList[0].responseCode;
        isBoostFactor = true;
      }

      var istimePeriodWave = comp.isWaveTimePeriod();
      comp.AssignDataToPreviousDataObject(comp.dataObject);

      comp.$unSubscribeSubmitData4 = comp.crossTabService
        .getOutPutData(
          comp.previewDataObject,
          comp.selected_client,
          comp.selected_study,
          target.DefaultSampleSize,
          comp.isFilteringActive,
          target.DefaultConfidenceLevel,
          target.isTotalBase,
          target.selectedWeight,
          weightColumnName,
          isBoostFactor,
          target.SignificanceVsReference,
          comp.columnLength,
          comp.dataArray,
          comp.isBrandAnalysis,
          comp.isAggregatedData,
          comp.isSemiAggregatedData,
          comp.isRespondentLevel,
          comp.aggregatedVariables,
          istimePeriodWave,
          target.isTotal
        )
        .subscribe({
          next: (result: any) => {
            if (result.HasValidData) {
              let JsonData = JSON.parse(result.Data);
              target.isReference = false;
              target.CrossTabOutPutEntireData = JsonData;
              comp.normalizeNestedChildFields(target.CrossTabOutPutEntireData);
              let chartType = target.isTranspose ? 'column' : 'bar';

              if (target.CrossTabOutPutEntireData.length > 0) {
                target.CrossTabOutPutData = target.CrossTabOutPutEntireData;
                if (!target.isTotal) {
                  target.CrossTabOutPutData = target.CrossTabOutPutEntireData.filter((x: any) => !x.isTotal);
                }

                if (target.isIndex && target.selectedIndex != '') {
                  comp.manipulateIndexData();
                }

                comp.BindTableOutput(target.CrossTabOutPutData, block);
                comp.sortOutputData(block);

                if (target.isTranspose) {
                  comp.handleOutputdataObjectOnTransposeSelect(block);
                }

                comp.crossTabService.setCrossTabOuputData(target.CrossTabOutPutData);

                if (target.isLineChartClick) {
                  comp.onTrendChartIconClick(block);
                } else if (target.isVerticalGroupBarChartClick || target.isVerticalBarChartClick) {
                  comp.VerticalChartClick(chartType, block);
                } else if (target.isVerticalStackChartClick) {
                  comp.onVerticalStackBarChartIconClick(chartType, block);
                }
              }
            }
            comp.usageDataLog(feature);
            target.isTableLoading = false;
          },
          error: (err: any) => {
            console.error('Error in createTable API:', err);
            target.isTableLoading = false;
          }
        });
    }

    if (target.IndexData && target.IndexData.length <= 1) {
      comp.isDisableReference = true;
    } else {
      comp.isDisableReference = columnDataLength > 1;
    }
  }

  static isTableVisible(comp: any, block: any): boolean {
    if (comp.isSnapshotVisible(block)) return false;

    if (block.isTableClick === true) return true;
    if (block.isChartView === true) return false;
    if (!block.analyticalData) return false;

    const data = comp.getOutputData(block);
    const hasData = !!(data?.Row?.length > 0);
    return hasData && comp.getMcode(block) !== 1;
  }


  static buildHistoricalTableData(comp: any, data: any): any {
    const output: any = { Column: [], Row: [] };
    try {
      const opData = typeof data.Data === 'string' ? JSON.parse(data.Data) : data.Data;

      output.flatData = opData;

      if (Array.isArray(opData) && opData.length > 0) {
        const validData = opData.filter((a: any) => a.colChild !== null && a.rowChild !== null);
        validData.forEach((item: any) => {
          const selections = TableOutputProcessorHelper.createSelections(item);
          const parents = TableOutputProcessorHelper.createParentObjects(item, selections);
          TableOutputProcessorHelper.processParent(parents.row, output.Row, selections.nested.row);
          TableOutputProcessorHelper.processParent(parents.col, output.Column, selections.nested.col);
        });
      } else {
        console.warn('[buildHistoricalTableData] opData is not a valid array or is empty:', opData);
      }
    } catch (e) {
      console.error('[buildHistoricalTableData] Error reconstructing table data:', e);
    }
    return output;
  }

}
